<template>
    <div class="d-flex align-center w-100" v-if="events.length > 0">
        <div class= "upcoming-events-slider-prev-btn" v-if="events.length > 3">
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.98389 1.34912L6.83154 0.196777L0.38623 6.64209L6.83154 13.0874L7.98389 11.9351L2.69092 6.64209L7.98389 1.34912Z" fill="#001055"/>
            </svg>
        </div>
        <div class="upcoming-events-slider-container">
            <swiper-container
            class="d-flex justify-center align-center"
            :breakpoints="{
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    grid: {
                        rows: 3,
                        fill: 'row'
                    }
                },
                920: {
                    slidesPerView: slidesCount,
                }
            }"
            :navigation="navigationParams"
            :allowTouchMove="events.length > 3"
            >
                <upcoming-events-slider-slide
                v-for="event in events"
                :key="event.text"
                :date="dateToString(event.date_start)"
                :text="event.name"
                @click="clickSlide(event)">
                </upcoming-events-slider-slide>
            </swiper-container>
        </div>
        <div class="upcoming-events-slider-next-btn" v-if="events.length > 3">
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.0161128 12.6509L1.16846 13.8032L7.61377 7.35791L1.16846 0.912597L0.0161128 2.06494L5.30908 7.35791L0.0161128 12.6509Z" fill="#001055"/>
            </svg>
        </div>
    </div>
</template>
<script>
import UpcomingEventsSliderSlide from '@/components/upcomingEvents/UpcomingEventsSliderSlide.vue'
import { useEventsStore } from '@/store/events'

export default {
    name: 'UpcomingEventsSlider',
    components: {
        UpcomingEventsSliderSlide
    },
    created() {
        window.addEventListener('resize', this.onResize);
    },
    computed:{
        events(){
            let allEvents = useEventsStore().allEvents
            let _copy = allEvents.slice()
            console.log(allEvents)
            _copy.sort((a,b)=>{
                console.log('a-b')
                console.log(a.date_start-b.date_start)
                if (a.date_start-b.date_start < 0){
                    return -1
                }
                if (a.date_start-b.date_start > 0){
                    return 1
                }
                if (a.date_start - b.date_start == 0){
                    return 0
                }
            })
            let _return = []
            let now = new Date
            for (let _event of _copy){
                if (_event.date_end - now < 0 ){
                    continue
                }
                _return.push(_event)
            }
            console.log('_return in events')
            console.log(_return)
            return _return
        },
        slidesCount(){
            if (this.events.length >= 4)
                return 3
            return this.events.length
        },
        navigationParams(){
            if (this.events.length < 3){
                return false
            }
            return {
                enable: true,
                nextEl: '.upcoming-events-slider-next-btn',
                prevEl: '.upcoming-events-slider-prev-btn'
            }
        }
    },
    methods: {
        onResize() {
            this.swiperMaxWidth = 'max-width:'+ (window.innerWidth - 208).toString() +'px'
        },
        dateToString(date){
            let days = date.getDate().toString()
            let month = date.getMonth().toString()
            let year = date.getFullYear().toString()
            return `${days}.${month}.${year}`
        },
        clickSlide(event){
            useEventsStore().setDefaultFilters()
            useEventsStore().setSelectedDate(event.date_start)
            this.$router.push({name: "UpcomingEventsPage", path: '/upcoming_events'})
        }
    }
}
</script>
